import React from 'react';

/**
 * Select input. `options` can be a list of strings or { value, label } objects.
 */
const SelectField = ({ name, label, value, onChange, options = [], error, required, placeholder = 'Selecione', ...rest }) => {
    const id = `psp-${name}`;

    return (
        <div className="psp-field">
            {label && (
                <label className="psp-field__label" htmlFor={id}>
                    {label}
                    {required && <span className="psp-required">*</span>}
                </label>
            )}
            <select
                id={id}
                name={name}
                value={value || ''}
                onChange={(event) => onChange(name, event.target.value)}
                className={`psp-input${error ? ' psp-input--invalid' : ''}`}
                aria-invalid={!!error}
                aria-describedby={error ? `${id}-error` : undefined}
                required={required}
                {...rest}
            >
                <option value="">{placeholder}</option>
                {options.map((option) => {
                    const item = typeof option === 'string' ? { value: option, label: option } : option;
                    return (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    );
                })}
            </select>
            {error && (
                <span id={`${id}-error`} className="psp-field__error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export default SelectField;
